import {
  KeyLoan,
  KeyLoanDisp,
  KeyLoanLog,
  KeyStatus,
  ReagentKeyStatus,
} from "../../../backend/src/types";
import { ENDPOINT } from "../endpoint/endpoint";
import { errorMessage } from "../function/errorMessage";

type Res<T> = { data: T; error?: any };

async function post<T>(url: string, body: unknown): Promise<T> {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const { data, error }: Res<T> = await res.json();
  if (!res.ok) throw new Error(error ?? "Server Error");
  return data;
}

// 鍵管理ONの試薬庫の貸出状況を取得する。
export async function getKeyStatusList(lab_id: number): Promise<KeyStatus[]> {
  try {
    return (await post<KeyStatus[]>(ENDPOINT.key.getKeyStatusList, { lab_id })) ?? [];
  } catch (error) {
    errorMessage("鍵の貸出状況の取得に失敗しました。", error);
    return [];
  }
}

// 貸出履歴（鍵の出納管理簿）を取得する。
export async function getKeyLoanList(lab_id: number): Promise<KeyLoanDisp[]> {
  try {
    return (await post<KeyLoanDisp[]>(ENDPOINT.key.getKeyLoanList, { lab_id })) ?? [];
  } catch (error) {
    errorMessage("鍵の貸出履歴の取得に失敗しました。", error);
    return [];
  }
}

// 1件の貸出記録の操作履歴を取得する（修正履歴の表示に使う）。
export async function getKeyLoanLogs(loan_id: number): Promise<KeyLoanLog[]> {
  try {
    return (await post<KeyLoanLog[]>(ENDPOINT.key.getKeyLoanLogs, { loan_id })) ?? [];
  } catch (error) {
    errorMessage("修正履歴の取得に失敗しました。", error);
    return [];
  }
}

// 鍵を借りる。既に他の人が借りている場合はエラーを投げる（呼び出し側で表示する）。
export async function borrowKey(storage_location_id: number): Promise<KeyLoan> {
  return post<KeyLoan>(ENDPOINT.key.borrowKey, { storage_location_id });
}

// 鍵を返す。
export async function returnKey(loan_id: number): Promise<KeyLoan> {
  return post<KeyLoan>(ENDPOINT.key.returnKey, { loan_id });
}

// 貸出・返却時間を手修正する。
export async function editKeyLoanTimes(
  loan_id: number,
  borrowed_at: string,
  returned_at: string | null
): Promise<KeyLoan> {
  return post<KeyLoan>(ENDPOINT.key.editKeyLoanTimes, {
    loan_id,
    borrowed_at,
    returned_at,
  });
}

// 試薬の試薬庫の鍵の状態（使用可否の判定に使う）を取得する。
export async function getReagentKeyStatus(
  reagent_id: number
): Promise<ReagentKeyStatus | null> {
  try {
    return await post<ReagentKeyStatus>(ENDPOINT.key.getReagentKeyStatus, {
      reagent_id,
    });
  } catch (error) {
    errorMessage("鍵の状態の取得に失敗しました。", error);
    return null;
  }
}
